import { useEffect, useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiErrorDetail, formatMoney } from "@/lib/api";
import { LineRow } from "./PaymentDialogs";
import { FormField, adminInput } from "./shared";

const LINE = { description: "", quantity: "1", rate: "" };

export const DraftDialog = ({ draft, onClose, onSaved }) => {
  const [items, setItems] = useState([]);
  const [due, setDue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!draft) return;
    setItems(draft.line_items.map((li) => ({ description: li.description, quantity: String(li.quantity), rate: li.rate ? String(li.rate) : "" })));
    setDue(draft.due_date || ""); setError("");
  }, [draft]);
  const setLine = (i, k, v) => setItems(items.map((li, j) => (j === i ? { ...li, [k]: v } : li)));
  const total = items.reduce((s, li) => s + (Number(li.quantity) || 0) * (Number(li.rate) || 0), 0);
  const save = async (e) => {
    e.preventDefault();
    const bad = !items.length || items.some((li) => !li.description.trim() || !Number.isInteger(Number(li.quantity)) || Number(li.quantity) < 1 || !(Number(li.rate) > 0));
    if (bad) return setError("Each line needs a description, a whole quantity of at least 1 and a positive rate");
    setBusy(true);
    try {
      await api.put(`/admin/payment-requests/${draft.id}`, { due_date: due || null, line_items: items.map((li) => ({ description: li.description.trim(), quantity: Number(li.quantity), rate: Number(li.rate) })) });
      onSaved();
    } catch (er) { setError(formatApiErrorDetail(er.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!draft} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="draft-dialog" className="max-h-[90vh] max-w-xl overflow-y-auto border-white/10 bg-[#0D111A]">
        <DialogHeader><DialogTitle className="text-white">Edit draft — {draft?.project_name}</DialogTitle></DialogHeader>
        <form onSubmit={save} noValidate className="space-y-4">
          <FormField id="draft-due" label="Due date">
            <input id="draft-due" type="date" value={due} onChange={(e) => setDue(e.target.value)} data-testid="draft-due-date" className={adminInput(false)} />
          </FormField>
          <div className="space-y-2">{items.map((li, i) => <LineRow key={i} li={li} i={i} onChange={setLine} onRemove={(j) => setItems(items.filter((_, k) => k !== j))} />)}</div>
          <button type="button" onClick={() => setItems([...items, LINE])} data-testid="draft-add-line" className="inline-flex items-center gap-1.5 text-xs text-cyan-300 hover:text-white"><Plus className="h-3.5 w-3.5" /> Add line</button>
          <p className="text-right text-sm text-slate-400">Total <span data-testid="draft-total" className="ml-2 font-display text-xl font-bold text-white">{formatMoney(total)}</span></p>
          {error && <p data-testid="draft-error" className="text-sm text-red-400">{error}</p>}
          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} data-testid="draft-cancel" className="rounded-full border border-white/10 px-5 py-2 text-sm text-slate-300 hover:bg-white/5">Cancel</button>
            <button type="submit" disabled={busy} data-testid="draft-save" className="inline-flex items-center gap-2 rounded-full bg-cyan-400 px-5 py-2 text-sm font-semibold text-[#07090E] hover:bg-cyan-300 disabled:opacity-60">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save draft</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
